import { Box, makeStyles, Paper, Typography, useTheme } from "@material-ui/core";
import { useMemo } from "react";
import RadarChart from "src/components/ScoringChart/RadarChart";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";
import { HealthTooltip } from "./HealthTooltip";

const useStyle = makeStyles((theme) => ({
  paper: {
    boxShadow: "0px 1px 3px -2px #0000001F",
    [theme.breakpoints.up("xs")]: {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    [theme.breakpoints.only("xs")]: {
      borderRadius: "10px",
      boxShadow: "0px 1px 3px 0px #0000001F",
    },
  },
}));

const getOption = (theme) => ({
  chart: {
    height: 400,
  },
  colors: ["rgb(119, 190, 255, 0.6)"],
  xAxis: {
    labels: {
      formatter: function () {
        return `
        <div style="padding:0.25rem;background-color:${
          theme.palette.type === THEME_MODE.DARK ? "#07111C" : "#F2F4F7"
        };border-radius:1px;">
          <div style="font-size:10px;color:${theme.palette.text.hint};">${this.value}</div>
        </div>`;
      },
      useHTML: true,
    },
  },
  yAxis: {
    showLastLabel: true,
    labels: {
      formatter: function () {
        return `<span style='font-size:14px;font-weight:500;'> ${this.value} </span>`;
      },
      useHTML: true,
    },
  },
  tooltip: {
    useHTML: true,
    style: {
      display: "block",
    },
    formatter: function () {
      const point = this.points[0];
      let data = `<div class="scoring-chart-tooltip-container">\
      <div class="scoring-chart-tooltip-circle" style="background:${point.color}"></div>\
      <span>${point.x}</span>:&nbsp;<b>${point.y}</b></div>`;
      return data;
    },
  },
});

export default function TokenHealthChart({ token }) {
  const theme = useTheme();
  const cls = useStyle();

  const series = useMemo(() => {
    if (token) {
      return [
        {
          name: "Health Overview",
          data: [
            token.credit_score,
            token.market_cap_score,
            token.trading_over_cap_score,
            token.price_over_highest_score,
            token.price_stability_score,
            token.number_of_transaction_score,
            token.holders_score,
            token.holder_distribution_score,
          ],
        },
      ];
    }
    return [
      {
        name: "Health Overview",
        data: [1, 1, 1, 1, 1, 1, 1, 1],
      },
    ];
  }, [token]);

  return (
    <>
      <Box pb={2} display="flex" justifyContent="flex-start" alignItems="center">
        <Typography variant="h4">Health Overview</Typography>
        <InfoIcon title={<HealthTooltip />} maxWidth="1000px" placement="bottom" />
      </Box>
      <Paper className={cls.paper}>
        <RadarChart
          categories={[
            "Health Score",
            "Market Cap Score",
            "Volume Score",
            "Price Score",
            "Price Stability Score",
            "Daily Tx Score",
            "Holders Score",
            "Holder Distribution Score",
          ]}
          series={series}
          option={getOption(theme)}
        />
      </Paper>
    </>
  );
}
